import { render, staticRenderFns } from "./partner-activity.vue?vue&type=template&id=51b0e2b5&scoped=true&"
import script from "./partner-activity.vue?vue&type=script&lang=js&"
export * from "./partner-activity.vue?vue&type=script&lang=js&"
import style0 from "./partner-activity.vue?vue&type=style&index=0&id=51b0e2b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b0e2b5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow})
